import { render } from "./CinematicOverlay.vue?vue&type=template&id=c017821c&scoped=true"
import script from "./CinematicOverlay.vue?vue&type=script&lang=js"
export * from "./CinematicOverlay.vue?vue&type=script&lang=js"

import "./CinematicOverlay.vue?vue&type=style&index=0&id=c017821c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c017821c"]])

export default __exports__